<ng-container *ngIf="role$ | async; let userRole">
  <ng-container *ngIf="profile$ | async; let currentProfile">
    <ng-container *ngIf="company$ | async; let company">
      <div
        class="header-nav"
        data-testid="company-members-header"
        [class.pilot]="userRole !== UserRole.ADMIN"
      >
        <div class="avatar">
          <app-avatar-company
            [name]="company.name"
            [area]="company.industry"
            [subarea]="company.fieldsOfApplication?.at(0) ?? ''"
            [address]="company.postalCode"
            [avatar]="company.avatar || 'assets/imgs/placeholder-avatar.png'"
          ></app-avatar-company>
        </div>
        <div *ngIf="userRole === UserRole.ADMIN">
          <span (click)="editCompany()" class="edit">
            <span class="edit-icon"></span>
            {{ 'members.table.edit_details' | translate }}
          </span>
        </div>
        <div *ngIf="userRole === UserRole.ADMIN" class="new-member-invitation">
          <span
            class="invite"
            data-testid="company-admin-invite-open"
            (click)="openInviteDialog()"
          >
            <span class="plus-icon"></span>
            {{ 'members.table.invite_new_members' | translate }}
          </span>
        </div>
        <div
          *ngIf="userRole !== UserRole.ADMIN"
          class="new-member-invitation"
          (click)="openConfirmLeave(currentProfile.id)"
        >
          <span class="leave">
            <span class="leave-icon"></span>
            {{ 'members.table.leave_company_group' | translate }}
          </span>
        </div>
      </div>
      <div class="content-table">
        <ng-container *ngIf="memberTableData$ | async; let tableData">
          <div class="titles-row">
            <div>{{ 'members.table.employee' | translate }}</div>
            <div>{{ 'members.table.role' | translate }}</div>
            <div>{{ 'members.table.email' | translate }}</div>
            <div *ngIf="tableData.showLicenseBatches">
              {{ 'members.table.license_batches' | translate }}
            </div>
            <div *ngIf="userRole === UserRole.ADMIN"></div>
          </div>
          <div class="break-line"></div>
          <div class="content" cdkMenuBar>
            <div
              class="content-row"
              *ngFor="let member of tableData.members; index as i"
              [attr.data-testid]="'company-admin-members-row-' + member.userId"
            >
              <div>{{ member.firstName }} {{ member.lastName }}</div>
              <div
                [attr.data-testid]="
                  'company-admin-members-cell-role-' + member.userId
                "
              >
                {{ getRoleLabel(member.role) }}
              </div>
              <div>{{ member.email }}</div>
              <div
                class="license-batches-cell"
                *ngIf="tableData.showLicenseBatches"
              >
                <ng-container
                  *ngFor="
                    let batch of getLicenseBatches(member);
                    let last = last;
                    trackBy: trackLicenseBatch
                  "
                >
                  <a
                    *ngIf="
                      userRole === UserRole.ADMIN ||
                      currentProfile.isMasteradmin
                    "
                    [routerLink]="
                      currentProfile.isMasteradmin
                        ? ['/admin/licenses/batches', batch.id]
                        : ['/licenses/batches', batch.id]
                    "
                    target="_blank"
                    rel="noopener noreferrer"
                    [attr.aria-label]="
                      'Open license batch ' + getLicenseBatchLabel(batch)
                    "
                    >{{ getLicenseBatchLabel(batch) }}</a
                  ><span
                    *ngIf="
                      userRole !== UserRole.ADMIN &&
                      !currentProfile.isMasteradmin
                    "
                    >{{ getLicenseBatchLabel(batch) }}</span
                  ><span *ngIf="!last">, </span>
                </ng-container>
                <span *ngIf="getLicenseBatches(member).length === 0">—</span>
              </div>
              <div class="three-dots" *ngIf="userRole === UserRole.ADMIN">
                <span
                  *ngIf="
                    tableData.members.length > 1 &&
                    !(i < 1 && !moreThanOneAdmin(tableData.members))
                  "
                  class="icon-dots"
                  cdkMenuItem
                  [cdkMenuTriggerFor]="memberMenu"
                  [attr.data-testid]="
                    'company-admin-members-cell-actions-' +
                    member.userId +
                    '-button'
                  "
                ></span>
              </div>
              <ng-template #memberMenu>
                <div class="member-menu" cdkMenu>
                  <ul>
                    <li
                      cdkMenuItem
                      *ngIf="
                        member.role !== UserRole.ADMIN &&
                        (i > 0 || moreThanOneAdmin(tableData.members))
                      "
                    >
                      <p
                        (click)="
                          changeRole(member, company, i < 1, UserRole.ADMIN)
                        "
                        [attr.data-testid]="
                          'company-admin-members-cell-actions-' +
                          member.userId +
                          '-set-admin'
                        "
                      >
                        {{ 'members.table.set_admin_role' | translate }}
                      </p>
                    </li>
                    <li
                      cdkMenuItem
                      *ngIf="
                        member.role !== UserRole.PILOT &&
                        (i > 0 || moreThanOneAdmin(tableData.members))
                      "
                    >
                      <p
                        (click)="
                          changeRole(member, company, i < 1, UserRole.PILOT)
                        "
                        [attr.data-testid]="
                          'company-admin-members-cell-actions-' +
                          member.userId +
                          '-set-pilot'
                        "
                      >
                        {{ 'members.table.set_pilot_role' | translate }}
                      </p>
                    </li>
                    <li
                      cdkMenuItem
                      *ngIf="
                        member.role !== UserRole.MAINTAINER &&
                        (i > 0 || moreThanOneAdmin(tableData.members))
                      "
                    >
                      <p
                        (click)="
                          changeRole(
                            member,
                            company,
                            i < 1,
                            UserRole.MAINTAINER
                          )
                        "
                        [attr.data-testid]="
                          'company-admin-members-cell-actions-' +
                          member.userId +
                          '-set-maintainer'
                        "
                      >
                        {{ 'members.table.set_maintainer_role' | translate }}
                      </p>
                    </li>
                    <li cdkMenuItem>
                      <p (click)="deleteMember(member, company, i < 1)">
                        {{
                          i > 0
                            ? ('members.table.remove_from_group' | translate)
                            : ('members.table.leave_group' | translate)
                        }}
                      </p>
                    </li>
                  </ul>
                </div>
              </ng-template>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
